import { useMutation, useQueryClient } from "@tanstack/react-query";
import adminApi from "../../api/adminApi";
type UpdateBranchPayload = {
    id: number;
    data: {
        name: string;
        address: string;
        phone: string;
    };
};

export const useUpdateBranch = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ id, data }: UpdateBranchPayload) =>
            adminApi.updateBranch(id, data),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ["branches"],
            });
        },
    });
};

